import { IPQuery, Metadata } from "../types";

export function transformIpQueryResponse(response: IPQuery | null): Metadata {
  const location = response?.location;
  const autonomousSystem = response?.network?.autonomous_system;

  return {
    zip: undefined,
    timezone: location?.timezone,
    region: undefined,
    organization_name: autonomousSystem?.organization ?? autonomousSystem?.name,
    country_code: autonomousSystem?.country,
    organization:
      autonomousSystem?.asn !== undefined && autonomousSystem?.asn !== null
        ? String(autonomousSystem.asn)
        : undefined,
    latitude:
      location?.latitude !== undefined && location?.latitude !== null
        ? location.latitude.toString()
        : undefined,
    longitude:
      location?.longitude !== undefined && location?.longitude !== null
        ? location.longitude.toString()
        : undefined,
    ip: response?.ip,
    city: location?.city,
    country: location?.country,
    continent: autonomousSystem?.country,
  };
}
